"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TradeTrustTokenStandard__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [],
  name: "AccessControlBadConfirmation",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    internalType: "bytes32",
    name: "neededRole",
    type: "bytes32"
  }],
  name: "AccessControlUnauthorizedAccount",
  type: "error"
}, {
  inputs: [],
  name: "EnforcedPause",
  type: "error"
}, {
  inputs: [],
  name: "ExpectedPause",
  type: "error"
}, {
  inputs: [],
  name: "InvalidAdminAddress",
  type: "error"
}, {
  inputs: [],
  name: "InvalidInitialization",
  type: "error"
}, {
  inputs: [],
  name: "InvalidTokenId",
  type: "error"
}, {
  inputs: [],
  name: "NotInitializing",
  type: "error"
}, {
  inputs: [],
  name: "RemarkLengthExceeded",
  type: "error"
}, {
  inputs: [],
  name: "TokenExists",
  type: "error"
}, {
  inputs: [],
  name: "TokenNotReturnedToIssuer",
  type: "error"
}, {
  inputs: [],
  name: "TransferFailure",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint64",
    name: "version",
    type: "uint64"
  }],
  name: "Initialized",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "PauseWithRemark",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Paused",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "previousAdminRole",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "newAdminRole",
    type: "bytes32"
  }],
  name: "RoleAdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleRevoked",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "UnpauseWithRemark",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Unpaused",
  type: "event"
}, {
  inputs: [],
  name: "ACCEPTER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "DEFAULT_ADMIN_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "MINTER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "RESTORER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "burn",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "genesis",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }],
  name: "getRoleAdmin",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "grantRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "hasRole",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "params",
    type: "bytes"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "mint",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "ownerOf",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "pause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "paused",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "remark",
  outputs: [{
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "callerConfirmation",
    type: "address"
  }],
  name: "renounceRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "restore",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "revokeRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "string",
    name: "baseURI",
    type: "string"
  }],
  name: "setBaseURI",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "adminRole",
    type: "bytes32"
  }],
  name: "setRoleAdmin",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "symbol",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "titleEscrowFactory",
  outputs: [{
    internalType: "contract ITitleEscrowFactory",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "tokenURI",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "transferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "unpause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";
const isSuperArgs = xs => xs.length > 1;
class TradeTrustTokenStandard__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.TradeTrustTokenStandard__factory = TradeTrustTokenStandard__factory;
_defineProperty(TradeTrustTokenStandard__factory, "bytecode", _bytecode);
_defineProperty(TradeTrustTokenStandard__factory, "abi", _abi);